import type { ServiceMiniEntity } from '@/features/service/domain/entities/ServiceMiniEntity'
import type { ServiceStatisticType } from '../enums/ServiceStatisticType'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'
import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'

export class StatisticFilterEntity {
  beginDate?: Date
  finalDate?: Date
  type!: ServiceStatisticType
  service?: ServiceMiniEntity
  region?: RegionMiniEntity
  branch?: BranchMiniEntity
}
